var AhrefsData = function(opts){
	var self = this;
	self.label = ko.observable(opts.label || '');
	self.hidden = ko.observable(!!(opts.hidden || false));
	self.data = ko.observable(opts || {});
};